import { Typography, makeStyles, Box } from '@material-ui/core';
import { Link } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.dark,
  },
}));

export function Copyright(): JSX.Element {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link to="/" className={classes.link}>
          LW SIM
        </Link>{' '}
        {new Date().getFullYear()}.
      </Typography>
    </Box>
  );
}
